import { useQuery } from '@tanstack/react-query';
import { apiClient as api } from '@plerionhq/design-system';

// NOTE: the assets/inventory MFE queries the same endpoint. If both MFEs mount
// simultaneously, use a shared query key to avoid cache collisions.
export function useListResourceTypes() {
  return useQuery({
    queryKey: ['listResourceTypes'],
    queryFn: () =>
      api
        .get<{ data: string[] }>(`/api/inventory/provider/resource-types`)
        .then((res) => res.data.data),
  });
}
